module.exports = __webpack_public_path__ + "img/prdx2.7ba599ef.jpg";